import { z } from 'zod';

export const HealthStatus = z.enum(['ok', 'degraded', 'fail']);
export type HealthStatus = z.infer<typeof HealthStatus>;

export const CheckResult = z.object({
  name: z.string(),
  status: HealthStatus,
  durationMs: z.number().nonnegative(),
  /** Safe, non-sensitive message. Never includes connection strings or error internals. */
  message: z.string().optional(),
});
export type CheckResult = z.infer<typeof CheckResult>;

/** GET /healthz — liveness: the process is up. No dependency checks. */
export const LivenessResponse = z.object({
  status: z.literal('ok'),
  service: z.string(),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
});
export type LivenessResponse = z.infer<typeof LivenessResponse>;

/** GET /readyz — readiness: dependencies required to serve traffic are reachable. */
export const ReadinessResponse = z.object({
  status: HealthStatus,
  service: z.string(),
  checks: z.array(CheckResult),
});
export type ReadinessResponse = z.infer<typeof ReadinessResponse>;
